/**
 * `localStorage`, for what is worth keeping across a reload. Every call survives a private window, blocked
 * site data, a full quota and a corrupt value: a read that cannot answer returns `undefined`, and a write that
 * cannot happen is dropped, so the caller carries on with what it holds in memory.
 */
export const storage = {
  read(key: string): string | undefined {
    try {
      return globalThis.localStorage?.getItem(key) ?? undefined;
    } catch {
      return undefined;
    }
  },

  readJson<T>(key: string): T | undefined {
    const raw = storage.read(key);
    if (!raw) return undefined;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return undefined;
    }
  },

  write(key: string, value: string): void {
    try {
      globalThis.localStorage?.setItem(key, value);
    } catch {
      /* dropped: see above */
    }
  },

  writeJson(key: string, value: unknown): void {
    storage.write(key, JSON.stringify(value));
  },

  remove(key: string): void {
    try {
      globalThis.localStorage?.removeItem(key);
    } catch {
      /* nothing to remove */
    }
  },
};
